<template>
  <div class="player" v-if="video">
    
    <iframe
      class="player__video"
      :src="video"
      scrolling="no"
      border="0"
      frameborder="no"
      framespacing="0"
      allowfullscreen="true"
    >
    </iframe>
    <!-- <video class="player__video" :src="video" ref="video"></video>
    <div class="player__fg" @click="onFgClick">
      <i class="iconfont acog-bofang player__fg__play" v-show="!playing"></i>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    video: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      playing: false
    };
  },
  methods: {
    onFgClick() {
      if (this.playing) {
        this.$refs.video.pause();
        this.playing = !this.playing;
      } else {
        this.$refs.video.play();
        this.playing = !this.playing;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.player {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: black;
  &__video {
    width: 100%;
    height: 100%;
  }
  &__fg {
    position: absolute;
    cursor: pointer;
    user-select: none;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    &__play {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 118px;
      display: block;
      color: #fefefe;
      opacity: 0.67;
    }
  }
}
</style>